export const CARD_WIDTH = '230px';
export const CARD_HEIGHT = '220px';
